import util from "../../../util/util";

export default {
  components: {},
  props: {
    num: Number,
    title: String,
    text: String,
    schedule: {
      type: Array,
      default: []
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    capitalize(val) {
      return util.capitalizeFirstLetter(val);
    }
  }
};
